<template>
  <div class="app-wrapp2">
    <section class="bg-clay">

        <div class="article-head article-head--a2">
          <div class="article-head__img article-head__img--2 img-w animated fadeInLeft">
            <img src="@/assets/img/article2/img1.png" alt="">
          </div>
          <h2 class="article-head__title article-head__title--a2">
            <div class="animated fadeInRight" style="opacity: 0;">
              {{ 'От жестокости людей страдают тысячи животных. Как в России нашли способ их спасти?' | typograf }}
            </div>
            <div class="article-head__line2 img-w">
              <img src="@/assets/img/article2/line1.png" alt="">
            </div>
            <div class="mobile-visible article-head__line article-head__line--a2 img-w">
              <img src="@/assets/img/article1/line1.png" alt="">
            </div>
          </h2>
        </div>

    </section>

    <section class="article-text bg-clay article-text--pre-blue">
      <div class="mobile-hidden article__img article__img1 img-w" v-animate-onscroll="'animated fadeInRight'">
        <img src="@/assets/img/article2/img2.png" alt="">
      </div>
      <div class="article-wrapper">
        <h3 class="article-text__h3" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          «Он одичал и был обречен на гибель»
        </h3>
        <p class="article-text__subtitle" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Когда Уно было шесть месяцев, его выбросили на улицу. С тех пор в его жизни начались недели ужаса, страха и боли. Щенка безжалостно избивали, гнали отовсюду и совсем не подкармливали.' | typograf }}
        </p>
        <p class="article-text__text" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Всему виной порода. Уно — метис мексиканской голой собаки Ксоло, одной из старейших пород в мире. Первые такие собаки появились в Мексике семь тысяч лет назад. Когда-то в ней видели земного представителя бога и активно использовали в ритуалах погребения. Считалось, что такие собаки сопровождали души мертвых в загробный мир.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Но Уно сам едва не попал в мир иной. Для жителей Ессентуков он выглядел больным и опасным. Пес быстро одичал, стал бояться людей и уже был обречен на гибель. Но в какой-то момент щенка нашли волонтеры. Казалось, что мучения вот-вот закончатся. Но случилось иначе. Испуганная собака в ужасе стала убегать от волонтеров и попала под машину.' | typograf }}
        </p>
        <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[0]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <div class="mobile-visible article__img article__img1 img-w" v-animate-onscroll="'animated fadeInRight'">
          <img src="@/assets/img/article2/img2.png" alt="">
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Поймать Уно удалось только сотрудникам службы отлова животных, которым пришлось воспользоваться дротиком со снотворным. Щенка забрала к себе  Валерия Некрасова — президент фонда помощи бездомным животным «Сильная Лара».' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Я забрала Уно к себе, вылечила его сломанную лопатку, а потом стала возвращать в нем доверие к людям. Только сейчас, спустя более полугода, он стал чуть отходить от жизни на улице, хотя до сих пор жутко боится незнакомцев. Жизнь на улице стала для него страшным потрясением», — рассказывает Некрасова.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Он до сих пор не идет на контакт со своей хозяйкой. А если и подходит, то только когда хочет сам. ' | typograf }}
        </p>
        <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[1]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img3 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article2/img3.png" alt="">
        </div>
        <div class="article__line article__line2 img-w" v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article2/line2.png" alt="">
        </div>
        <div class="article-wrapper article-wrapper--shifted article-wrapper--mob-m">
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'История Уно — одна из сотен тысяч. По данным ассоциации «Благополучие животных», сегодня в российских регионах проживают более 660 тысяч бездомных собак без учета московских дворняг. При этом больше всего таких животных в Татарстане (24,5 тысячи), Краснодарском крае (24 тысячи) и Башкирии (22 тысячи).' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'По словам директора Фонда защиты городских животных Екатерины Дмитриевой, сегодня домашних животных на улицы в России выбрасывают буквально каждый день. При этом, отмечает эксперт, три-четыре поколения уличных животных просто не существует: все собаки и кошки, которые встречаются на улице, — это либо первое выброшенное поколение, либо его потомство. Дальше такие животные просто не выживают.' | typograf }}
          </p>
          <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
            {{ 'В России 660 тысяч бездомных собак.' | typograf }}
          </h3>
          <div class="article-text__note2" v-animate-onscroll="'animated fadeInUp'">
            <span>Источник:</span> Всероссийская ассоциация «Благополучие животных» (данные приводятся без учета Москвы)
          </div>
          <div class="article-text__quote2" v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote-black.png" alt="">
            </div>
            {{ '«Наша организация каждый день получает около 20 звонков или о потерянных животных, или с просьбой забрать питомца, потому что нет возможности или желания его содержать. Это очень актуальная проблема, которая действительно требует решения», — объясняет Дмитриева.' | typograf }}
          </div>
        </div>
        <div class="article-wrapper">
          <Loading :class="{'is-loading-animated': isLoading}" />
          <div class="observer-move"></div>
          <Layers />
        </div>
      </div>
    </section>

    <section id="element-container" class="article-text article-text--blue article-text--blue1 -no-blue">
      <div id="element-content">
        <div class="article-wrapper article-wrapper--inner">
          <h3 id="element" class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Владельцы ответят по закону»' | typograf }}
          </h3>
          <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Уже осенью 2021 года жизнь животных в России должна кардинально измениться.' | typograf }}
          </p>
          <p class="article-text__enlarged" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Вот уже несколько лет в России активно формируется новая отрасль законодательства, защищающего животных. Под конец 2018 года был принят федеральный закон (ФЗ) №498 «Об ответственном обращении с животными». Логичным продолжением этой работы стала подготовка поправок в КоАП РФ, предусматривающих наказание за нарушение запретов, прописанных в законе.' | typograf }}
          </p>
        </div>
        <div class="article-text__shifted-box">
          <div class="article__img article__img4 img-w" v-animate-onscroll="'animated fadeInLeft'">
            <img src="@/assets/img/article2/img4.png" alt="">
          </div>
          <div class="article__line article__line4 img-w" v-animate-onscroll="'animated fadeInDown'">
            <img src="@/assets/img/article2/line4.png" alt="">
          </div>
          <div class="article-wrapper article-wrapper--inner article-wrapper--shifted-left">
            <div class="article-text__quote2" v-animate-onscroll="'animated fadeInUp'">
              <div class="article-text__quote-icon img-w">
                <img src="@/assets/img/quote.png" alt="">
              </div>
              {{ '«У нас в принципе не было раньше такого законодательства, пока мы не начали этим заниматься четыре года назад с появлением нашего партийного проекта. А сейчас это самостоятельная отрасль законодательства, очень системная, в диапазоне от поправок в Конституцию и базового закона об ответственном обращении с животными до поправок в Уголовный, Гражданский и Административный кодексы», — говорит председатель комитета Госдумы по экологии и охране окружающей среды, депутат фракции «Единой России» Владимир Бурматов.' | typograf }}
            </div>
            <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[2]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
            </div>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Владимир Бурматов вместе с депутатом Павлом Крашенинниковым внес в Госдуму ряд поправок в КоАП РФ, касающихся штрафов за нарушения в сфере защиты животных.' | typograf }}
            </p>
          </div>
        </div>
        <div class="article-wrapper article-wrapper--inner">
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'По мнению Валерии Некрасовой, такие меры — важный шаг в борьбе за права животных в России. При этом, отмечает хозяйка Уно, суть штрафов не в самих наказаниях, а в том, чтобы люди хорошо думали, прежде чем заводить собаку. «Если потенциальные владельцы питомца будут понимать, что ответят по закону, если выбросят его на улицу, то десять раз взвесят свои возможности — и таких историй, как с Уно, не будет», — считает зоозащитница.' | typograf }}
          </p>
        </div>
        <div class="article-text__shifted-box">
          <div class="article__img article__img5 img-w" v-animate-onscroll="'animated fadeInRight'">
            <img src="@/assets/img/article2/img5.png" alt="">
          </div>
          <div class="article__line article__line5 img-w" v-animate-onscroll="'animated fadeInDown'">
            <img src="@/assets/img/article2/line5.png" alt="">
          </div>
          <div class="article-wrapper article-wrapper--inner article-wrapper--shifted-right article-wrapper--pb">
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Кроме того, отмечает Некрасова, введение на законодательном уровне ответственности за брошенных питомцев может стать ключом к решению проблемы всех бездомных животных в стране: большинство бродяг или когда-то были домашними, или появились от них. При этом бездомные животные размножаются: помет из десяти щенков через 8-10 месяцев уже потенциально сможет дать свое потомство.' | typograf }}
            </p>
            <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
              <span class="char"
                    v-for="(letter, index) in titles[3]"
                    :key="letter.id"
                    :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
            </div>
            <div class="article-text__quote2" v-animate-onscroll="'animated fadeInUp'">
              <div class="article-text__quote-icon img-w">
                <img src="@/assets/img/quote.png" alt="">
              </div>
              {{ '«А это уже полноценная стая, которая будет страдать от всех превратностей жизни на улице и представлять потенциальную опасность для людей. Так что ответственность для тех, кто выбрасывает животных, должна быть обязательно. Это движение в правильном направлении», — заключает президент «Сильной Лары».' | typograf }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="article-text">
      <div class="article__img article__img6 img-w" v-animate-onscroll="'animated fadeInLeft'">
        <img src="@/assets/img/article2/img6.png" alt="">
      </div>
      <div class="article-wrapper article-wrapper--mt3">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Сохранить жизнь живых существ»' | typograf }}
        </h3>
        <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Между тем список поправок в КоАП РФ, которые подготовила фракция «Единой России», направлен не только на защиту прав выброшенных животных.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Законопроект, подготовленный Владимиром Бурматовым и Павлом Крашенинниковым, предусматривает штрафы до 50 тысяч рублей за нарушение правил содержания животных в муниципальных приютах, до 100 тысяч рублей — за жестокое обращение с животными при отсутствии признаков уголовно наказуемого деяния, и до 150 тысяч рублей — за содержание и использование животных, включенных в перечень запрещенных к содержанию.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Отдельные поправки предусматривают административные штрафы за жестокое обращение с животными при перевозке: на физических лиц — от 10 до 20 тысяч рублей, на должностных лиц — от 25 до 40 тысяч, на юридических — от 100 до 150 тысяч.' | typograf }}
        </p>
        <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[4]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <div class="article-text__quote2" v-animate-onscroll="'animated fadeInUp'">
          <div class="article-text__quote-icon img-w">
            <img src="@/assets/img/quote.png" alt="">
          </div>
          {{ '«Мы рассчитываем, что это поможет сократить количество случаев, когда животные страдают в результате безалаберных действий сargo-служб в аэропортах, сделает безопасной перевозку питомцев самолетами, поездами, автомобильным и другим транспортом. А главное, поможет сохранить жизнь живых существ, которых многие наши граждане считают членами своих семей», — отмечает Владимир Бурматов.' | typograf }}
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'По словам Бурматова, депутаты от партии «Единая Россия» внесут в нижнюю палату парламента пакет поправок по защите животных до конца лета.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'При этом в зоозащитном сообществе их ждут давно: директор Фонда защиты городских животных Екатерина Дмитриева надеется, что поправки будут приняты уже в осеннюю сессию Госдумы.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Внесение этих поправок существенным образом расширит практику по защите прав животных: авторы законопроекта берут определение жестокого обращения из ФЗ №498, а там его трактовка довольно обширна», — объясняет эксперт.' | typograf }}
        </p>
      </div>
      <div class="article-text__shifted-box">
        <div class="article-wrapper article-wrapper--pb2 article-wrapper--shifted-right">
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Благодаря поправкам в КоАП, жестоким обращением с животными в России будут считаться не только их смерть или увечья, как в статье 245 («Жестокое обращение с животными») УК РФ, но и, к примеру, истязания голодом или жаждой. Важно и то, что административные дела возбуждаются проще, чем уголовные, отмечает Дмитриева.' | typograf }}
          </p>
          <div class="article-text__quote2" v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote.png" alt="">
            </div>
            {{ '«Поправки в КоАП, касающиеся защиты животных, безусловно, нужны и полезны. Все они родились из практики: скажем, ответственность за жестокое обращение при перевозке животных — это следствие тех громких случаев, когда собаки и кошки гибли во время транспортировки общественным транспортом», — говорит директор Международного благотворительного фонда помощи животным «Дарящие надежду» Светлана Сафонова.' | typograf }}
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'По словам Сафоновой, ответственность за содержание и использование животных, включенных в перечень запрещенных к содержанию, — это меры, направленные против тех, кто до сих пор пытается держать львов, тигров и других экзотических животных едва ли не в городских квартирах, что является «абсолютно дикой практикой».' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Я горячо поддерживаю поправки в КоАП. К ним хотелось бы добавить еще и обязательную регистрацию животных, чтобы было совершенно понятно, кто отвечает за жизнь того или иного живого существа в России», — заключает эксперт.' | typograf }}
          </p>
        </div>
        <div class="article__img article__img7 img-w" v-animate-onscroll="'animated fadeInRight'">
          <img src="@/assets/img/article2/img7.png" alt="">
        </div>
        <div class="article__line article__line6 img-w" v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article2/line6.png" alt="">
        </div>
      </div>
      <div class="article-wrapper">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Как хотят наказывать за жестокое обращение с животными?' | typograf }}
        </h3>
      </div>
    </section>

    <section class="info-table">
      <div class="info__table img-w">
        <img src="@/assets/img/article2/table.png" alt="">
      </div>
    </section>

    <div class="info-stars info-stars--a2">
      <div class="info-stars__note">
        <span>Источник:</span> Всероссийская ассоциация «Благополучие животных»
      </div>
    </div>
  </div>
</template>

<script>
import './article.styl'
import './info.styl'
import Loading from '@/components/Loading/Loading.vue'
import Layers from '@/components/Layers/Layers.vue'

export default {
  name: 'Article2',
  data () {
    return {
      observer: null,
      isLoading: false,
      titles: [
        'Страх животного перед людьми был столь велик, что даже с серьезной травмой пес продолжал бежать.',
        'Сколько потребуется времени для того, чтобы молодой пес стал вновь доверять людям, — не знает никто.',
        'За выброшенных на улицу животных предлагается штрафовать на сумму до 30 тысяч рублей.',
        '«Этот закон —  ключ к решению проблемы всех бездомных животных в стране» <br> Валерия Некрасова',
        'Штрафы за жестокое обращение с животными при перевозке поднимут до 150 тысяч рублей'
      ]
    }
  },
  components: {
    Loading, Layers
  },
  methods: {
    disable () {
      const target = document.querySelector('#app')
      target.ontouchstart = (e) => {
        e.preventDefault()
      }
    },
    enable () {
      const target = document.querySelector('#app')
      target.ontouchstart = () => {
        return true
      }
    },
    onDone () {
      (document.getElementById('element-container')).classList.remove('-scale', '-no-blue')
      document.querySelector('html').classList.remove('-lock')
      this.enable()
    },

    onIntersection (entries) {
      entries.forEach((entry) => {
        entry.target.classList.toggle('-visible', entry.isIntersecting)

        if (entry.target.classList.contains('-visible')) {
          (document.getElementById('element-container')).classList.add('-scale')

          document.querySelector('html').classList.add('-lock')
          this.disable()
          this.isLoading = true

          setTimeout(() => {
            const layers = document.querySelectorAll('.bottom-layer')
            for (const layer of layers) {
              layer.classList.toggle('is-active')
            };

            this.$scrollTo('#element', 1800, { cancelable: false, offset: -60, onDone: this.onDone, onCancel: this.onDone })

            this.observer.disconnect()
          }, 1500)
        }
      })
    },

    initObserver () {
      this.observer = new IntersectionObserver(this.onIntersection, {
        root: null,
        threshold: 0.5
      })

      const nodes = document.querySelectorAll('.observer-move')

      nodes.forEach((node) => {
        this.observer.observe(node)
      })
    }
  },
  mounted () {
    const titles = []

    this.titles.forEach((item) => {
      titles.push(item.split(' '))
    })
    this.titles = titles

    this.initObserver()
  }
}
</script>

<style scoped lang="stylus">

.article-cir__21
  transition: all 1s ease-out
  transform none

#element-container
  transition: all 1s ease-out

  &.-no-blue
    background #f9f9f9

    .article-cir__21, .article__line3
      opacity 0

  #element-content
    transform-origin 50% 0
    transition: all 0.4s ease-out

  &.-scale
    #element-content
      transition: none
      transform scale(0.8)

.article__img1
  position: absolute
  width: 20rem
  right: 0
  top: 22rem

  @media(max-width: 950px)
    float: right

.article__img2
  position: absolute
  width: 22rem
  right: 0
  top: 65rem

.article__img3
  position: absolute
  width: 48rem
  left: 0
  top: 10rem
  z-index: 10

.article__line2
  position: absolute
  width: 54rem
  top: 3rem
  left: -2rem
  z-index: 5

.article__img4
  position: absolute
  width: 59rem
  left: 0
  top: -5rem
  z-index: 15

.article__img5
  position: absolute
  width: 59rem
  right: 0
  top: -5rem
  z-index: 15

  @media(max-width: 950px)
    float: right

.article__line5
  position: absolute
  width: 38rem
  top: -1rem
  right: -1rem
  z-index: 14

.article__img6
  position: absolute
  width: 21rem
  left: 0
  top: 16rem

  @media(max-width: 950px)
    width: 21rem !important
    margin: 0

.article__img7
  position: absolute
  width: 65rem
  right: 0
  top: 1rem
  z-index: 10

  @media(max-width: 950px)
    float: right
    margin: 0

.article__line6
  position: absolute
  right: 0
  top: 0
  width: 41rem
  z-index: 5

.article__img8
  position: absolute
  width: 59rem
  right: 0
  top: 0
  z-index: 15

.article__line3
  position: absolute
  right: 5rem
  top: -18rem
  width: 55.7rem
  z-index: 5
  transition: all 1s ease-out
  transition-delay 1s

.article__line4
  position: absolute
  width: 28rem
  top: -3rem
  left: -2rem

</style>
